import { ModalJustificativaComponent } from './../../../shared/components/modal-justificativa/modal-justificativa.component';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ToastrService } from "ngx-toastr";
import { IItemSolicitacaoTecnicaModel } from "./../../../models/item-solicitacao-tecnica.model";
import { ISolicitacaoTecnicaModel, ISolicitacaoTecnicaUnidadeGestoraModel } from "./../../../models/solicitacao-tecnica.model";
import { SolicitacaoTecnicaService } from "./../../../services/solicitacao-tecnica.service";
import { BaseFormComponent } from "./../../../shared/components/base-form/base-form.component";
import { ModalItemSolicitacaoComponent } from "../modal-item-solicitacao/modal-item-solicitacao.component";
import Swal from 'sweetalert2';
import { AuthService } from '../../../services/auth.service';

const sortingDataAccessor = (item, property) => {
	switch (property) {
		case "numero":
			return item?.numero;
		case "titulo":
			return item?.titulo;
		case "descricao":
			return item?.descricao;
		case "responsavelDelegado":
			return item?.nomeAuditor;
		case "status":
			return item?.status?.descricao;
		case "ug":
			return item?.siglaUg;
		case "responsavel":
			return item?.nomeAuditor;

		default:
			return item[property];
	}
}

@Component({
	selector: "app-solicitacao-tecnica-form",
	templateUrl: "./solicitacao-tecnica-form.component.html",
})
export class SolicitacaoTecnicaFormComponent
	extends BaseFormComponent
	implements OnInit, AfterViewInit {
	public tituloPagina = "";
	public responder = false;
	public semDadosItens = true;
	public selectedModel: any;
	public pageEvent: any;
	public itensSolicitacaoDataSource = new MatTableDataSource<IItemSolicitacaoTecnicaModel>([]);
	public model: ISolicitacaoTecnicaModel = {} as ISolicitacaoTecnicaModel;

	public displayedColumnsItems: string[] = [
		"numero",
		"titulo",
		"responsavelDelegado",
		"status",
		"statusAvaliacao",
		"actions",
	];

	public usuarioLogadoEhRespSolic: boolean = false;
	public usuarioLogadoEhRespUG: boolean = false;
	public usuarioLogadoEhDelegPermUG: boolean = false;
	public podeProrrogarPrazo: boolean = false;

	constructor(
		route: ActivatedRoute,
		toastr: ToastrService,
		router: Router,
		localeService: BsLocaleService,
		public authService: AuthService,
		public matDialog: MatDialog,
		private solicicataoTecnicaService: SolicitacaoTecnicaService
	) {
		super(route, toastr, router, localeService, matDialog);
	}

	@ViewChild("TablePaginator", { static: true })
	tablePaginator: MatPaginator;
	@ViewChild("tabela1", { static: true }) tabela1: MatSort;


	ngOnInit(): void {
		const path = this.route.snapshot.routeConfig.path?.toString();
		if (path?.endsWith("responder")) {
			this.tituloPagina = "Responder Solicitação Técnica";
			this.responder = true;
		}
		if (path?.endsWith("visualizar")) {
			this.visualizar = true
		}

		this.obterSolicitacaoTecnica();
	}

	ngAfterViewInit(): void {
		this.itensSolicitacaoDataSource.paginator = this.tablePaginator;
		this.itensSolicitacaoDataSource.sortingDataAccessor = sortingDataAccessor;
		this.itensSolicitacaoDataSource.sort = this.tabela1
	}

	public obterSolicitacaoTecnica() {

		this.solicicataoTecnicaService
			.obterPorId(this.id)
			.then((res) => {
				this.model = res.dados;

				this.usuarioLogadoEhRespSolic = this.authService.usuario.id == this.model?.internaResponsavelId;
				this.usuarioLogadoEhRespUG = this.authService.usuario.id == this.model?.internaUnidadeGestora.responsavelId;
				this.usuarioLogadoEhDelegPermUG = this.authService.usuario.id == this.model?.internaUnidadeGestora.responsavelDelegadoPermanenteId;
				this.podeProrrogarPrazo = this.usuarioLogadoEhRespSolic || this.usuarioLogadoEhRespUG || this.usuarioLogadoEhDelegPermUG;

				if (this.visualizar) {
					this.tituloPagina = "Visualizar Solicitação Técnica - " + (this.model.numero ? this.model.numero : "");
				}
				this.itensSolicitacaoDataSource = new MatTableDataSource(
					res.dados.item
				);

				this.itensSolicitacaoDataSource.paginator = this.tablePaginator;
				this.itensSolicitacaoDataSource.sortingDataAccessor = sortingDataAccessor;
				this.itensSolicitacaoDataSource.sort = this.tabela1

				this.semDadosItens = this.itensSolicitacaoDataSource.filteredData.length === 0;

			})
			.catch((err) => {
				this.exibirMensagemErro(err.mensagem?.descricao);
			});
	}

	public async visualizarItem(id: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component-resposta";
		dialogConfig.width = "80%";
		dialogConfig.height = "90vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
			titulo: "Visualizar Item de Solicitação",
			id: id,
			solicitacaoTecnicaId: this.id,
			numeroSolicitacao: this.model?.numero,
			visualizar: true,
			statusSolicitacao: this.model?.status.codigo,
			idUnidadeGestora: this.model?.internaUnidadeGestoraId,
			usuarioLogadoEhRespSolic: this.usuarioLogadoEhRespSolic,
			usuarioLogadoEhRespUG: this.usuarioLogadoEhRespUG,
			usuarioLogadoEhDelegPermUG: this.usuarioLogadoEhDelegPermUG
		};

		const modal = this.matDialog.open(
			ModalItemSolicitacaoComponent,
			dialogConfig
		);
	}

	public responderItem(id: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component-resposta";
		dialogConfig.width = "80%";
		dialogConfig.height = "90vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			titulo: "Responder Item de Solicitação",
			id: id,
			solicitacaoTecnicaId: this.id,
			responder: this.responder,
			numeroSolicitacao: this.model?.numero,
			visualizar: false,
			statusSolicitacao: this.model?.status.codigo,
			idUnidadeGestora: this.model?.internaUnidadeGestoraId,
			usuarioLogadoEhRespSolic: this.usuarioLogadoEhRespSolic,
			usuarioLogadoEhRespUG: this.usuarioLogadoEhRespUG,
			usuarioLogadoEhDelegPermUG: this.usuarioLogadoEhDelegPermUG
		};

		const modal = this.matDialog.open(
			ModalItemSolicitacaoComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((data) => {
			this.obterSolicitacaoTecnica();
		});
	}

  public obterReferencia(tipoTrabalhoCodigo: number): string {
    switch (tipoTrabalhoCodigo) {
      case 7:
        return 'Auditoria/Planejamento';
      case 14:
        return 'Auditoria/Execução';
      default:
        return '';
    }
  }

	public prorrogarPrazo() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component-prorrogar";
		dialogConfig.width = '45vw';
		dialogConfig.maxHeight = '85vh';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = { prorrogarPrazo: true };

		const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);

		modal.afterClosed().subscribe((data) => {
			if (data) {
				this.processarAfterClosedModalProgrrogacaoPrazo(data);
			}
		});
	}

	private processarAfterClosedModalProgrrogacaoPrazo(data: any) {
		this.solicicataoTecnicaService.prorrogarPrazo(this.id, data).then((res) => {
			if (res.sucesso) {
				this.mostraMensagemSucesso(res.mensagem.descricao);
				this.router.navigate(["/solicitacao-tecnica"]);
			} else {
				this.mostraMensagemAlerta(res.mensagem.descricao);
			}
		}).catch((err) => {
			this.mostraMensagemErro(err?.mensagem?.descricao);
		})
	}

	public pageChanged(e) { }

	public onBack() {
		this.router.navigate(["/solicitacao-tecnica"]);
	}

	private mostraMensagemSucesso(descricao: string): void {
		Swal.fire({
			toast: true,
			position: "top-end",
			icon: "success",
			text: descricao,
			showConfirmButton: false,
			timer: 5000,
			timerProgressBar: true,
		});
	}

	private mostraMensagemAlerta(descricao: string): void {
		Swal.fire({
			toast: true,
			position: "top-end",
			icon: "warning",
			text: descricao,
			showConfirmButton: false,
			timer: 5000,
			timerProgressBar: true,
		});
	}

	private mostraMensagemErro(descricao: string): void {
		Swal.fire({
			toast: true,
			position: "top-end",
			icon: "error",
			text: descricao,
			showConfirmButton: false,
			timer: 5000,
			timerProgressBar: true,
		});
	}

	public isStatusAvaliacaoVazio(status: any): boolean {
		return !status || Object.keys(status).length === 0;
	}

	formatarTooltipAvaliacao(element: any): string {
		const data = element?.dataHoraAvaliacao
			? new Date(element.dataHoraAvaliacao).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelNomeAvaliacao || 'Avaliador desconhecido';
		const comentario = element?.comentarioAvaliacao || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

	formatarTooltipCanc(element: any): string {

		const data = element?.dataHoraCanc
			? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
		const comentario = element?.justificativa || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

	exibirBotaoResponderItem(element: any): boolean {

		if (!element)
			return false;

		// regra 1: não estar em modo visualizar
		if (this.visualizar)
			return false;

		// regra 2: status permitido
		const statusPermitidos = [2, 4, 5, 7];
		if (!statusPermitidos.includes(element?.status?.codigo))
			return false;

		// regra 3: status de avaliação diferente de 1
		if (element?.statusAvaliacao?.codigo === 1)
			return false;

		// regra 4: caso o usuário logado não seja o responsável pela solicitação ou o responsavel pela UG ou delegado permanente da UG
		// ele só poderá responder o item, se ele estiver como delegado do item
		let usuarioLogadoEhRespSolic = this.authService.usuario.id == this.model?.internaResponsavelId;
		let usuarioLogadoEhRespUG = this.authService.usuario.id == this.model?.internaUnidadeGestora.responsavelId;
		let usuarioLogadoEhDelegPermUG = this.authService.usuario.id == this.model?.internaUnidadeGestora.responsavelDelegadoPermanenteId;

		if ((!usuarioLogadoEhRespSolic && !usuarioLogadoEhRespUG && !usuarioLogadoEhDelegPermUG) && (element?.responsavelId != this.authService.usuario.id))
			return false;

		// regra 5: caso o usuário logado não seja o responsável pela solicitação ou o responsavel pela UG ou delegado permanente da UG
		// se o item já estiver respondido, o delegado nao pode mais responder
		if ((!usuarioLogadoEhRespSolic && !usuarioLogadoEhRespUG && !usuarioLogadoEhDelegPermUG) && (element?.responsavelId == this.authService.usuario.id) && (element?.status?.codigo == 4))
			return false;

		return true;
	}
}
